import React, {Component} from 'react';
import Auxw from '../../hoc/Auxw';
import Burger from '../../components/Burger/Burger';
import BuildControls from '../../components/Burger/BuidControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary';
import axios from '../../axios-orders';
import Spinner from '../../components/UI/Spinner/Spinner';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';



const INGREDIENT_PRICES = {
	salad: .5,
	cheese: .4,
	meat: 1.3,
	bacon: .7
};


class BurgerBuilder extends Component {
	
	state = {
		ingredients: null,
		totalPrice: 4,
		purchasable: false,
		purchasing: false,
		loading: false,
		error: false
		
	};
	
	componentDidMount(){
		axios.get('https://my-burger-king.firebaseio.com/ingredients.json')
			.then(response => {
				this.setState({ingredients: response.data})
			})
			.catch(error => {
				this.setState({
					error: true
				})
			})
	}

	
	updatePurchaseState (ingredients) {
		const sum = Object.keys(ingredients)
			.map( igKey => {
				return ingredients[igKey]
			})
			.reduce((sum, current) => {
				return sum+current
			});
		
		this.setState({ purchasable: sum > 0})
	}
	
	addIngredientHandler = (type) => {
		const oldCount = this.state.ingredients[type];
		const updateCount = oldCount +1;
		const updatedIngredients = {
			...this.state.ingredients
		};
		updatedIngredients[type] = updateCount;
		const priceAddition = INGREDIENT_PRICES[type];
		const oldPrice = this.state.totalPrice;
		const newPrice =  oldPrice + priceAddition;
		this.setState({
			totalPrice: newPrice, ingredients: updatedIngredients
		});
		this.updatePurchaseState(updatedIngredients);
	};
	
	removeIngredientHandler = (type) => {
		const oldCount = this.state.ingredients[type];
		if(oldCount <= 0){
		    return
		}
		const updateCount = oldCount - 1;
		const updatedIngredients = {
			...this.state.ingredients
		};
		updatedIngredients[type] = updateCount;
		const priceDeduction = INGREDIENT_PRICES[type];
		const oldPrice = this.state.totalPrice;
		const newPrice = oldPrice - priceDeduction;
		this.setState({
			totalPrice: newPrice, ingredients: updatedIngredients
		})
		this.updatePurchaseState(updatedIngredients);
	};
	
	purchaseHandler = () => {
		this.setState({
			purchasing: true
		})
	};
	
	purchaseCancelHandler = () => {
		this.setState({
			purchasing: false
		})
	};
	
	purchaseContinueHandler = () => {
		this.setState({
			loading: true
		});
		const order = {
			ingredients: this.state.ingredients,
			price: this.state.totalPrice,
			customer: {
				name: 'Max',
				address: {
					street: 'testStreet',
					zipCode: '455456',
					country: 'German'
				},
				email: 'test@test.com'
			},
			deliveryMethod: 'fastest',
		};
		axios.post('/orders.json', order)
			.then(response => {
				this.setState({
					loading: false,
					purchasing: false,

				})
			})
			.catch(error => {
				this.setState({
					loading: false,
					purchasing: false,
				})
			})
	};
	
	render(){
		const disabledInfo = {
			...this.state.ingredients
		};
		for (let key in disabledInfo){
			disabledInfo[key] = disabledInfo[key] <= 0;
		}
		
		let burger = this.state.error ? <p>Ingredients can't reloaded</p> :  <Spinner/>;
		let orderSummary = null;
		if(this.state.ingredients){
			burger = (
				<Auxw>
					<Burger ingredients = {this.state.ingredients}/>
					<BuildControls
						ingredientAdded = {this.addIngredientHandler}
						ingredientRemove = {this.removeIngredientHandler}
						disabled = {disabledInfo}
						price = {this.state.totalPrice}
						purchasable={this.state.purchasable}
						ordered={this.purchaseHandler}
					/>
				</Auxw>
			);
			orderSummary = <OrderSummary
				price={this.state.totalPrice}
				purchaseCanceled={this.purchaseCancelHandler}
				purchaseContinued={this.purchaseContinueHandler}
				ingredients={this.state.ingredients}/>;
		}
		
		if(this.state.loading){
			orderSummary = <Spinner/>;
		}
		return(
			<Auxw>
				<Modal
					show={this.state.purchasing}
					modalClosed={this.purchaseCancelHandler}>
					{orderSummary}
				</Modal>
				{burger}
			</Auxw>
		);
	}
};

export default withErrorHandler(BurgerBuilder, axios);


// WEBPACK FOOTER //
// ./src/containers/BurgerBuilder/BurgerBuildeer.js